import { Link } from "react-router-dom";

const stats = [
  { value: "1,280+", label: "收录作品" },
  { value: "36", label: "细分类型" },
  { value: "每日", label: "资讯更新" },
  { value: "9.2", label: "平均观众评分" },
];

const features = [
  { icon: "ri-play-circle-line", title: "入口清晰", desc: "播放入口为演示占位，作品信息完整可查。" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "按类型、地区、年份与连载状态快速定位。" },
  { icon: "ri-bookmark-3-line", title: "本地收藏", desc: "收藏记录保存在你的浏览器，无需注册。" },
  { icon: "ri-device-line", title: "双端适配", desc: "桌面大屏与手机端都能舒适浏览。" },
];

export default function AboutPreview() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16" aria-labelledby="about-preview-title">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <p className="text-[11px] font-bold tracking-[0.2em] text-accent-600 mb-2">ABOUT FAIRY ANIME</p>
          <h2 id="about-preview-title" className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight leading-snug">
            认真记录每一部动画,
            <br className="hidden md:block" />
            也认真对待每个观众
          </h2>
          <p className="mt-4 text-[14px] leading-7 text-foreground-600 max-w-[520px]">
            妖精动漫专注国产、日韩动画的内容整理与资讯跟进。我们不做夸张的营销口号，只把作品信息、剧集进度和行业动态整理清楚，让每一次点开都有收获。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-900 hover:bg-primary-800 text-background-50 text-[13px] font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们 <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-[13px] font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line" /> 试试站内搜索
            </Link>
          </div>
        </div>

        <div>
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
                <p className="text-2xl md:text-3xl font-black text-primary-800 tracking-tight">{stat.value}</p>
                <p className="mt-1 text-[12px] text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-3 md:mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {features.map((f) => (
              <div key={f.title} className="rounded-lg bg-background-50 border border-background-200 p-3.5">
                <div className="flex items-center gap-2">
                  <span className="w-7 h-7 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center shrink-0">
                    <i className={`${f.icon} text-sm`} />
                  </span>
                  <p className="text-[13px] font-semibold text-foreground-900">{f.title}</p>
                </div>
                <p className="mt-2 text-[12px] leading-5 text-foreground-500">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}